import { API } from '@apis/endPoints';
import { axiosService, checkError } from '@services';

export default async function getWeather(plant_id) {
  if(!plant_id) {
    throw new Error('Plant ID is required');
  }

  const res = await axiosService({
    method: 'post',
    data: {
      path: `/devices`,
      plant_id: plant_id,
    },
    apiPath: `${API.PLANT_MANAGEMENT}`,
  });

  const deviceId = res?.data?.result?.devices[0]?.deviceId;

  if (res?.codeHTTP === 200 && deviceId) {
    const resWeather = await axiosService({
      method: 'post',
      data: {
        path: `/measurements/sets/Sensor/Recent`,
        device_id: deviceId,
      },
      apiPath: `${API.DEVICE_MANAGEMENT}`,
    });

    if (resWeather?.codeHTTP === 200) {
      const typeDeviceDataM = resWeather.data?.result?.device?.name === 'DATA M';

      let ambientTemperature;
      let moduleTemperature;
      if (typeDeviceDataM) {
        const resWeatherTypeDataM = await axiosService({
          method: 'post',
          data: {
            path: `/measurements/sets/Sensor/Recent`,
            plant_id: plant_id,
          },
          apiPath: `${API.PLANT_MANAGEMENT}`,
        });
        if (resWeatherTypeDataM?.codeHTTP === 200) {
          const weather = resWeatherTypeDataM.data?.result?.set[0];
          if (weather) {
            ambientTemperature = weather.ambientTemperature;
            moduleTemperature = weather.moduleTemperature;
          }
        }
      } else {
        const weather = resWeather.data?.result?.set[0];
        if (weather) {
          ambientTemperature = weather.ambientTemperature;
          moduleTemperature = weather.moduleTemperature;
        }
      }
      return {
        ambientTemperature,
        moduleTemperature,
        typeDeviceDataM,
      };
    } else {
      return checkError(res, getWeather, plant_id);
    }
  }

  return {
    codeHTTP: res?.codeHTTP,
    data: res?.data,
  }
}
